import { useContext } from 'react'
import { HomeContext } from '../state/home-context'
import LastFourWeeksStorePerformance from './last-four-weeks-store-performance/last-four-weeks-store-performance'
import LastFourWeeksTeamPerformance from './last-four-weeks-team-performance/last-four-weeks-team-performance'

const LastFourWeeksPerformance = () => {
  const { aggregation } = useContext(HomeContext)

  return (
    <>
      {aggregation === 'STORE' && <LastFourWeeksStorePerformance />}
      {aggregation === 'TEAM' && <LastFourWeeksTeamPerformance />}
    </>
  )
}

export default LastFourWeeksPerformance
